import { render, staticRenderFns } from "./MelaregaloPaymentTypeList.vue?vue&type=template&id=7059e105"
import script from "./MelaregaloPaymentTypeList.vue?vue&type=script&lang=js"
export * from "./MelaregaloPaymentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports